/* Migali pilot bootstrap: local candidate, no storage writes or native form mutations. */
(function (global) {
  'use strict';
  if (global.BTSMigaliPilotBootstrap) return;
  global.BTSMigaliPilotBootstrap = true;
  var doc = global.document, PID = '9748644626730', TEMPLATE = 'pf-3144562d', THEME = '191736545578';
  var BASES = {
    '50073175621930': 'EVOX-1RG-PH Configuration: (6)Slide-out Baskets + (1) Removable Shelf',
    '50073175654698': 'EVOX-1RG-LB Configuration: (6) Removable Shelves',
    '50073175687466': 'EVOX-1RG-LB-RC Configuration: (6)Slide-out Baskets + Remote Compressor & Condensing Unit included'
  };
  var HOST = '[data-bts-migali-host]', READY = 'bts-migali-owned-ready';
  var host, source, seed, wrap, button, form, section, core, timer, observer;
  var failed = false, started = false, ready = false, baseline = [];
  function all(selector, root) { return Array.from((root || doc).querySelectorAll(selector)); }
  function only(selector, root) { var nodes = all(selector, root); return nodes.length === 1 ? nodes[0] : null; }
  function status(message) {
    var el = host && host.querySelector('.bts-owned-quote-status');
    if (el) { el.setAttribute('data-bts-message-kind', 'error'); el.textContent = message; }
  }
  function stripFlags() {
    ['bts-quote-list-pilot', 'bts-controlled-quote-test', 'bts-buybox-170-ready', READY].forEach(function (name) {
      if (doc.body.classList.contains(name)) doc.body.classList.remove(name);
    });
  }
  function quarantine() {
    stripFlags();
    all('.bts-ql-widget,#bts-ql-dialog,[data-bts-buybox-cart-root]').forEach(function (node) {
      if (!started || baseline.indexOf(node) !== -1) return;
      if (!node.hasAttribute('data-bts-migali-quarantined')) node.setAttribute('data-bts-migali-quarantined', '');
      if (!node.hidden) node.hidden = true;
      if (node.tagName === 'DIALOG' && node.open && typeof node.close === 'function') node.close();
    });
    all(HOST).forEach(function (h) {
      if (h.getAttribute('data-bts-native-state') !== 'fallback') h.setAttribute('data-bts-native-state', 'fallback');
      // Keep error feedback visible; only the action/card are hidden on fallback.
      all('[data-bts-migali-wrap]', h).forEach(function (w) { if (w.hidden) w.hidden = false; });
      all('[data-bts-owned-quote]', h).forEach(function (b) { if (!b.hidden) b.hidden = true; if (!b.disabled) b.disabled = true; });
    });
  }
  function fallback(reason) {
    failed = true; ready = false;
    clearTimeout(timer);
    if (source) source.removeAttribute('data-bts-ql-product');
    // A removed script may still execute. Sticky state + seed removal + the class/
    // child observer below quarantine a late core without clearing its stored list.
    if (core) core.remove();
    doc.body.classList.add('bts-migali-owned-fallback');
    quarantine();
    if (reason) status(reason + ' Please use the original Request a Quote option.');
  }
  function asset(value, filename) {
    try {
      var url = new URL(value, global.location.href);
      return url.protocol === 'https:' && (url.origin === global.location.origin || url.hostname === 'cdn.shopify.com') &&
        url.pathname.endsWith('/' + filename) ? url.href : null;
    } catch (_) { return null; }
  }
  function structure() {
    var box = only('[data-pf-type="ProductBox"][data-product-id="' + PID + '"]');
    var candidate = box && only('form.pf-product-form[data-productid="' + PID + '"][action*="/cart/add"]', box);
    if (!candidate || all('form.pf-product-form[data-productid="' + PID + '"]').length !== 1 ||
        !candidate.contains(host) || box.closest('.section--canonical,[data-product-recommendations]')) return null;
    var sec = box.closest('[id$="__' + TEMPLATE + '"]');
    var ids = all('[name="id"]', candidate), models = all('select.pf-variant-select', candidate);
    var options = all('select[name="mw_opts[o_2171669]"]', candidate);
    var optionHost = only('[id="o_2171669"]', candidate);
    var atcs = all('button[data-pf-type="ProductATC"][data-product-id="' + PID + '"]', candidate);
    if (!sec || ids.length !== 1 || ids[0].type !== 'hidden' || ids[0].disabled || !/^\d+$/.test(ids[0].value) ||
        models.length !== 1 || !!models[0].name || models[0].multiple || models[0].disabled ||
        options.length !== 1 || !optionHost || !optionHost.contains(options[0]) || options[0].multiple || options[0].disabled ||
        atcs.length < 1 || atcs.length > 2 || only(HOST) !== host || only('[data-bts-migali-wrap]', host) !== wrap ||
        only('[data-bts-owned-quote]') !== button || only('.bts-owned-quote-wrap') !== wrap ||
        !wrap.contains(button) || button.closest('form') !== candidate ||
        candidate.querySelector('[data-open-titration],.js-titration-trigger,.js-biomiga-rfq,[data-open-biomiga-rfq]')) return null;
    var labels = Object.keys(BASES).map(function (id) { return BASES[id]; });
    var modelOptions = Array.from(models[0].options);
    if (modelOptions.length !== 3 || labels.some(function (label) {
      return modelOptions.filter(function (o) { return o.value === label && o.textContent.trim() === label; }).length !== 1;
    })) return null;
    var values = Array.from(options[0].options);
    if (values.filter(function (o) { return o.value === 'v_18808907' && /^Yes(?:\s|\(|$)/.test(o.textContent.trim()); }).length !== 1 ||
        values.filter(function (o) { return o.value === 'v_18808908' && o.textContent.trim() === 'No'; }).length !== 1 ||
        values.some(function (o) { return o.value !== '' && o.value !== 'v_18808907' && o.value !== 'v_18808908'; })) return null;
    // Native hidden ID may be an APO-generated variant. Canonical model resolution
    // and required Yes/No validation belong exclusively to the shared core.
    return { form: candidate, section: sec, optionHost: optionHost };
  }
  function mounted() {
    return !!global.BTSQuoteList && all('.bts-ql-widget').length === 1 && all('#bts-ql-dialog').length === 1 &&
      wrap && !wrap.hidden && button && button.closest('form') === form && form.contains(host);
  }
  function presentation(state) {
    
    if (!global.Shopify.country || global.Shopify.country === 'US') return;
    doc.body.classList.add('bts-migali-international');
    var banners = all('.bts-intl-banner,.international-annc-bar-main', section);
    if (!banners.length) {
      var copy;
      try { copy = JSON.parse(only('[data-bts-international-copy]').textContent); } catch (_) { return; }
      if (!copy || copy.version !== 1 || typeof copy.banner !== 'string' || !copy.banner.length || copy.banner.length >= 500) return;
      var banner = doc.createElement('div'), p = doc.createElement('p');
      banner.className = 'bts-intl-banner'; banner.setAttribute('data-bts-migali-banner', '');
      p.textContent = copy.banner; banner.appendChild(p); section.insertBefore(banner, section.firstChild); banners = [banner];
    }
    // A hidden parent is handled too; no duplicate of an existing notice is added.
    banners.forEach(function (banner) {
      for (var node = banner; node && node !== section; node = node.parentElement) {
        if (!node.hasAttribute('data-bts-migali-banner-visible')) node.setAttribute('data-bts-migali-banner-visible', '');
      }
    });
  }
  function check() {
    if (failed || (host && host.getAttribute('data-bts-native-state') === 'fallback')) { if (!failed) fallback('Quote Cart is unavailable.'); else quarantine(); return; }
    if (!started) return;
    var state = structure();
    if (!state || state.form !== form || state.section !== section) { fallback('The product controls changed.'); return; }
    if (!mounted()) { if (ready) fallback('Quote Cart could not stay connected.'); return; }
    if (ready && !state.optionHost.querySelector('[data-bts-migali-white-glove-note]')) presentation(state);
    if (!ready) {
      ready = true; clearTimeout(timer);
      host.setAttribute('data-bts-native-state', 'ready');
      doc.body.classList.add(READY);
      presentation(state);
      var initialStatus = host.querySelector('.bts-owned-quote-status');
      if ((!global.Shopify.country || global.Shopify.country === 'US') && initialStatus &&
          initialStatus.textContent === 'Preparing Quote Cart. Your shopping cart stays unchanged.') {
        initialStatus.setAttribute('data-bts-message-kind', 'info');
        initialStatus.textContent = 'Choose a model and White Glove Yes or No, then request a quote. Your shopping cart stays unchanged.';
      }
      // Leave all core pending/error text and disabled states intact, especially
      // international async verification and the required White Glove selection.
    }
  }
  function start() {
    host = only(HOST);
    if (!host) return;
    source = only('[data-bts-migali-seed]'); wrap = only('[data-bts-migali-wrap]', host); button = only('[data-bts-owned-quote]', host);
    doc.body.classList.add('bts-migali-pilot-page');
    host.addEventListener('bts:migali-fallback', function () { fallback('Quote Cart could not load.'); });
    // Event-driven integrity/lateness guard, not a network or perpetual timer poll.
    observer = new MutationObserver(check);
    observer.observe(doc.body, { subtree: true, childList: true, attributes: true,
      attributeFilter: ['class', 'hidden', 'disabled', 'name', 'data-bts-native-state', 'data-productid', 'data-product-id'] });
    try { seed = JSON.parse(source.textContent); } catch (_) {}
    var theme = global.Shopify && global.Shopify.theme;
    var coreURL = source && asset(source.getAttribute('data-bts-migali-core-url'), 'bts-quote-cart.js');
    var logoURL = source && asset(source.getAttribute('data-bts-migali-logo-url'), 'bts-quote-test-logo.png');
    if (!theme || theme.role !== 'main' || String(theme.id) !== THEME || !source || !wrap || !button || !button.disabled ||
        !host.contains(source) || source.getAttribute('data-bts-migali-theme') !== THEME || source.getAttribute('data-bts-buybox-template') !== TEMPLATE ||
        host.getAttribute('data-bts-template-host') !== TEMPLATE || host.getAttribute('data-bts-native-product') !== PID ||
        host.getAttribute('data-bts-native-state') !== 'pending' || !seed || String(seed.id) !== PID || !seed.handle ||
        !Array.isArray(seed.variants) || Object.keys(BASES).some(function (id) {
          return seed.variants.filter(function (v) { return String(v.id) === id && v.option1 === BASES[id]; }).length !== 1;
        }) || !coreURL || !logoURL) { fallback('Quote Cart could not verify this product.'); return; }
    function attempt(last) {
      if (failed || started) return;
      var state = structure();
      if (!state) { if (last) fallback('Quote Cart could not verify the product controls.'); return; }
      if (global.BTSQuoteList || doc.querySelector('script[data-bts-unified-quote-preview],[data-bts-ql-product]') ||
          all('.bts-ql-widget,#bts-ql-dialog').length) { fallback('Another quote interface is already present.'); return; }
      form = state.form; section = state.section;
      baseline = all('.bts-ql-widget,#bts-ql-dialog,[data-bts-buybox-cart-root]'); started = true;
      source.setAttribute('data-bts-ql-product', '');
      core = doc.createElement('script'); core.src = coreURL;
      core.setAttribute('data-bts-unified-quote-preview', ''); core.setAttribute('data-bts-unified-context', 'buybox');
      core.setAttribute('data-bts-quote-test', PID); core.setAttribute('data-bts-test-template', TEMPLATE);
      core.setAttribute('data-bts-quote-logo', logoURL);
      core.onerror = function () { fallback('Quote Cart could not load.'); };
      core.onload = function () { if (failed) { quarantine(); return; } check(); if (!mounted()) fallback('Quote Cart did not initialize.'); };
      timer = setTimeout(function () { if (!ready) fallback('Quote Cart timed out.'); }, 10000);
      doc.body.appendChild(core);
    }
    [0, 150, 500, 1500, 3000, 6000, 10000].forEach(function (ms, index, times) {
      setTimeout(function () { attempt(index === times.length - 1); }, ms);
    });
  }
  // Always after DCL, including a slow defer asset. The complete-state listener
  // also covers dynamic inclusion after DCL on browsers lacking navigation timing.
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true; doc.removeEventListener('readystatechange', onState);
    setTimeout(start, 0);
  }
  function onState() { if (doc.readyState === 'complete') schedule(); }
  var navigation = global.performance && global.performance.getEntriesByType && global.performance.getEntriesByType('navigation')[0];
  if (doc.readyState === 'complete' || (navigation && navigation.domContentLoadedEventStart > 0)) schedule();
  else {
    doc.addEventListener('DOMContentLoaded', schedule, { once: true });
    doc.addEventListener('readystatechange', onState);
  }
})(window);
